export default __webpack_public_path__ + "static/media/ok_green.47123234.svg";